import { UIHeading3, UIText2, Image, UIHeading4 } from '@cian/ui-kit';
import { IconActionChevronRight16, IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import * as React from 'react';

import { NBSP } from 'shared/constants';

import logo from './assets/lock.png';
import * as styles from './styles.css';

export interface IBookedFromDeveloperContactsLayoutProps {
  onClick(): void;
  buttons?: React.ReactNode;
  redesigned: boolean;
}

export const NewbuildingBookedFromDeveloperButton: React.FC<
  React.PropsWithChildren<IBookedFromDeveloperContactsLayoutProps>
> = ({ onClick, buttons, redesigned }) => {
  return (
    <div className={styles['container']} data-testid="booked-from-developer-button">
      <div
        role="button"
        className={clsx(styles['message'], { [styles['message--redesigned']]: redesigned })}
        onClick={redesigned ? undefined : onClick}
      >
        {redesigned && (
          <div className={styles['logo']}>
            <Image src={logo} height={40} width={40} />
          </div>
        )}
        {!redesigned && (
          <div className={styles['icon']}>
            <IconFunctionalLock16 />
          </div>
        )}

        <div className={styles['info']}>
          <div className={styles['title']}>
            {redesigned && <UIHeading4 as="h4">Квартира забронирована</UIHeading4>}
            {!redesigned && <UIHeading3 as="h3">Квартира забронирована</UIHeading3>}
          </div>
          {redesigned && (
            <UIText2>
              Застройщик может записать вас в{NBSP}очередь или{NBSP}подобрать похожую
            </UIText2>
          )}
          {!redesigned && <UIText2 color="gray60_100">Подберём похожую квартиру</UIText2>}
        </div>
        {!redesigned && (
          <div className={styles['arrow']}>
            <IconActionChevronRight16 />
          </div>
        )}
      </div>
      {buttons && (
        <div className={clsx(styles['buttons'], { [styles['buttons--redesigned']]: redesigned })}>{buttons}</div>
      )}
    </div>
  );
};
